import { Fragment, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { IonButton, IonCol, IonGrid, IonRow } from "@ionic/react";
import { TimetableType } from "../../hooks/useTimetablePeriods";
import CoverTeacherSelect, { SelectedCoverTeacher } from "./CoverTeacherSelect";
import {
  OnCallTeacher,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  useOnCallTeachers,
} from "../../hooks/useOnCallTeachers";

import "./CoverTeacherChooser.css";
import OnCallsSelector from "./OnCallsSelector";
import { formatDate } from "../../utils";

interface ContainerProps extends RouteComponentProps<any> {
  timetableType: TimetableType;
  timetableDate: string | null;
  timetablePeriod: string | null;
  onSelectOnCallTeacher: (teacher: OnCallTeacher) => void;
  onSelectAvailableTeacher: (teacher: SelectedCoverTeacher, inst?: any) => void;
  coverTeachers: SelectedCoverTeacher[];
}

// eslint-disable-next-line react-refresh/only-export-components
const CoverTeacherChooser: React.FC<ContainerProps> = ({
  timetableType,
  timetableDate,
  timetablePeriod,
  onSelectOnCallTeacher,
  onSelectAvailableTeacher,
  coverTeachers,
}) => {

  const [mode, setMode] = useState("oncall");

  const changeDisplayMode = (mode: string) => {
    console.log(mode);
    setMode(mode);
  }

  return (
    <Fragment>
      <IonGrid>
        <IonRow>
          <IonCol size="5" className={mode === "oncall" ? "is-selected" : ""}>
            <IonButton color="primary" expand="block" fill="clear"
              onClick={() => { changeDisplayMode("oncall"); }}>
              On Call Teachers</IonButton>
          </IonCol>
          <IonCol size="5" className={mode === "available" ? "is-selected" : ""}>
            <IonButton color="primary" expand="block" fill="clear"
              onClick={() => { changeDisplayMode("available") }}>
              Available Teachers

            </IonButton>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol className={"choose-oncall" + (mode !== "oncall" ? " ion-hide" : "")}>
            <OnCallsSelector
              timetableDate={
                timetableDate ? formatDate(timetableDate) : ""
              }
              timetableType={
                timetableType ?? "Secondary"
              }
              timetablePeriod={
                timetablePeriod ?? ""
              }
              coverTeachers={coverTeachers}
              onSelected={onSelectOnCallTeacher}
            />
          </IonCol>
          <IonCol className={"choose-available" + (mode !== "available" ? " ion-hide" : "")}>
            <CoverTeacherSelect
              onChange={onSelectAvailableTeacher}
              searchDate={
                timetableDate ? formatDate(timetableDate) : ""
              }
              display="inline"
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </Fragment >
  );
};

export default withRouter(CoverTeacherChooser);
